import { useQuery } from '@tanstack/react-query';
import { queryKeys } from 'configs';
import { useOrganizationDeletionEligibilityApi } from 'services/solution1/useOrganizationDeletionEligibilityApi';

export const useGetOrganizationDeletionEligibility = (
  organizationId: string | undefined,
  enabled = true
) => {
  const { getOrganizationDeletionEligibility } =
    useOrganizationDeletionEligibilityApi();

  return useQuery({
    queryKey: [queryKeys.getOrganizationDeletionEligibility, organizationId],
    queryFn: () => getOrganizationDeletionEligibility(organizationId ?? ''),
    enabled: Boolean(organizationId) && enabled
  });
};
